<template>
    <Table
        :disabled="disabled"
        :isBorder="true"
    >
        <template #thead>
            <tr>
                <th class="w-4 pl-4">
                    <slot name="pickAll" />
                </th>
                <th class="w-1/5">
                    保單號碼
                </th>
                <th class="w-1/4">
                    主約險種
                </th>
                <th class="w-32">
                    被保險人
                </th>
                <th class="w-36">
                    目前繳費方式
                </th>
                <th class="w-28">
                    幣別
                </th>
                <th v-if="disabled" />
            </tr>
        </template>
        <template #tbody>
            <template
                v-for="item in data"
                :key="item.fullPolicyNo"
            >
                <tr @click="$emit('checkedPolicy', item.fullPolicyNo)">
                    <td class="text-center pl-4">
                        <Checkbox
                            v-if="!disabled"
                            :checkedValues="selectedList"
                            :value="item.fullPolicyNo"
                            name="table"
                            class="items-baseline mb-0 mr-0"
                            @change="$emit('checkedPolicy', item.fullPolicyNo)"
                        />
                    </td>
                    <td>
                        {{ item.fullPolicyNo }}
                    </td>
                    <td class="break-all">
                        {{ item.itemName }}
                    </td>
                    <td class="break-all">
                        {{ item.name }}
                    </td>
                    <td>
                        {{ item.payKindText }}
                    </td>
                    <td>
                        {{ item.currencyText }}
                    </td>
                    <td
                        v-if="disabled"
                        class="pr-0 flex justify-end items-center"
                    >
                        <div class="bg-gray-400 text-sm text-white p-1.5 w-[5.5rem]">
                            {{ item.memo }}
                        </div>
                    </td>
                </tr>
            </template>
        </template>
    </Table>
</template>

<script>
import Table from '@/components/table/TableBase.vue';
import Checkbox from '@/components/checkboxs/Checkbox.vue';

export default {
    components: {
        Table,
        Checkbox,
    },
    props: {
        selectedList: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => []
        }
    },
    emits: ['checkedPolicy'],
};
</script>
